import { MouseEvent } from 'react';

export type Navigation = {
  links?: FooterLinkSection[];
  appStores?: AppStoreItem[];
  socialMedia?: SocialMediaItem[];
};

export type NavigationClickHandler = (
  name: string,
  details?: Record<string, string | undefined>,
  event?: Event | MouseEvent
) => void;

export type FooterLinkSection = {
  name: string;
  label: string;
  items: FooterLinkItem[];
  testId?: string;
};

export type FooterLinkItem = {
  name: string;
  label: string;
  id?: string;
  type: 'link' | 'externalLink';
  url: string | Record<string, string>;
  crawlable?: boolean;
  alt?: string;
  testId?: string;
};

export enum AppStoreEnum {
  AppStore = 'AppStore',
  PlayStore = 'PlayStore'
}

export type AppStoreItem = {
  name: AppStoreEnum;
  label: string;
  url: string;
};

export enum SocialMediaEnum {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Blog = 'Blog',
  YouTube = 'YouTube',
  Instagram = 'Instagram'
}

export type SocialMediaItem = {
  name: SocialMediaEnum;
  label: string;
  url: string;
};

export type Experiment = {
  isActive: boolean;
  key: string;
  ticketCode?: string;
  variation?: string;
};
